import React from 'react';
import styled from 'styled-components';
import { FONT } from '@constants/app';

export const BaseButtonWrapper = styled.button`
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  box-shadow: none;
  transition: background-color 300ms, color 300ms;

  border-radius: 6px;
  white-space: nowrap;

  * {
    font-family: ${FONT.bold};
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
`;

export const BaseButton = (props) => {
  const { children, onClick, disabled } = props;
  return (
    <BaseButtonWrapper $disabled={disabled} onClick={onClick}>
      {children}
    </BaseButtonWrapper>
  );
};
